import React, { useEffect } from "react";

import "./about.scss";

function AboutComponent(props) {
  return (
    <>
      <section>
        <h1 > <span className="page-title border-small">About Us</span></h1>
        <div className="container-fluid">
          <div className="content bg-yellow">
            {props.children}
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutComponent;
